import { store as createStore } from '@risingstack/react-easy-state'

const store = createStore({
  redirection: null,
  setRedirection (location) {
    store.redirection = location
  },
  go () {
    if (store.redirection) {
      const location = JSON.parse(JSON.stringify(store.redirection))
      store.redirection = null
      return location
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/stores/location.js